import {Paper, Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useGroup} from "../contexts/GroupContext";
import LoadingComponent from "../pages/LoadingComponent";
import Grid from "@mui/material/Grid";
import {makeStyles, withStyles} from '@mui/styles';
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ButtonComponent = () => {

    const {locationDocs, videoNames, sendUserInput, selectedBot, dolphinEnabled} = useGroup()
    const [isReady, setIsReady] = useState(false)
    const [locationNames, setLocationNames] = useState([]);
    //Escort Behavior
    const [escortPatientName, setEscortPatientName] = useState("");
    const [escortFromLocation, setEscortFromLocation] = useState("");
    const [escortToLocation, setEscortToLocation] = useState("");
    //Fetch Behavior
    const [fetchItemName, setFetchItemName] = useState("");
    const [fetchFromLocation, setFetchFromLocation] = useState("");
    //Say Behavior
    const [sayText, setSayText] = useState("");
    //Display Behavior
    const [displayText, setDisplayText] = useState("");
    //Play Video Behavior
    const [playVideoName, setPlayVideoName] = useState("");
    //Come Here Behavior
    const [openHere, setOpenHere] = useState(false);
    const [hereLocation, setHereLocation] = useState("");
    const [selected, setSelected] = useState("");
    //Go To Behavior
    const [goToLocation, setGoToLocation] = useState("");
    //Display QR Code Behavior
    const [QRText, setQRText] = useState("");
    const [QRHeader, setQRHeader] = useState("");
    //Check In Behavior
    const [checkInLocation, setCheckInLocation] = useState("");

    const [componentOpen, setComponentOpen] = useState(true)

    const useStyles = makeStyles((theme) => ({
        root: {
            padding: theme.spacing(2,0),
            flexGrow: 1,
        },
        accordionDivider: {
            marginTop: theme.spacing(-2) + "!important",
        },
        evenGridItem: {
            backgroundColor: theme.palette.custom.backgroundTwo,
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5)
        },
        oddGridItem: {
            backgroundColor: theme.palette.custom.backgroundThree,
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5)
        }
    }));

    const classes = useStyles();

    const HeaderTypography = withStyles((theme) => ({
        root: {
            paddingLeft: theme.spacing(2),
            fontWeight: 'bold',
            textAlign: 'start',
            fontSize: 'large'
        },
    }))(Typography);

    const BodyTypography = withStyles((theme) => ({
        root: {
            paddingLeft: 0,
            // fontWeight: 'bold',
            textAlign: 'center',
            fontSize: 'large'
        },
    }))(Typography);

    const handleEscortPatientChange = (event) => {
        setEscortPatientName(event.target.value);
    };

    const handleEscortToChange = (event) => {
        setEscortToLocation(event.target.value);
    };

    const handleEscortFromChange = (event) => {
        setEscortFromLocation(event.target.value);
    };

    const handleEscortSubmit = () => {
        if (/\S/.test(escortToLocation) && /\S/.test(escortFromLocation)) {
            if (/\S/.test(escortPatientName)) {
                sendUserInput("Escort " + escortPatientName + " from " + escortFromLocation + " to " + escortToLocation);
            } else {
                sendUserInput("Escort from " + escortFromLocation + " to " + escortToLocation);
            }
        } else {
            if (/\S/.test(escortToLocation)) {
                sendUserInput("Escort to " + escortToLocation);
            }
            else {
                alert("Please select a destination for the escort command before sending!");
            }
        }
    };

    const generateEscortBehavior = () => {
        //TODO: make min width for component and format correctly based on that
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Escort</HeaderTypography>
                    </Grid>
                    <Grid item xs zeroMinWidth>
                        <TextField variant={'standard'} autoComplete='off' onChange={handleEscortPatientChange} id="escortPatientField" label="Name..." fullWidth/>
                    </Grid>
                    <Grid item xs sx={{alignSelf:'end'}}>
                        <BodyTypography>from</BodyTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} onChange={handleEscortFromChange} select value={escortFromLocation}
                                   id="escortFromLocationField" label="Location..." fullWidth>
                            {locationNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs sx={{alignSelf:'end'}}>
                        <BodyTypography>to</BodyTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'}  onChange={handleEscortToChange} select value={escortToLocation}
                                   id="escortToLocationField" label="Location..." fullWidth>
                            {locationNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleEscortSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleFetchItemChange = (event) => {
        setFetchItemName(event.target.value);
    };

    const handleFetchFromChange = (event) => {
        setFetchFromLocation(event.target.value);
    };

    const handleFetchSubmit = () => {
        if (/\S/.test(fetchFromLocation)) {
            if (/\S/.test(fetchItemName)) {
                sendUserInput("Fetch " + fetchItemName + " from " + fetchFromLocation);
            } else {
                sendUserInput("Fetch from " + fetchFromLocation);
            }
        } else {
            alert("Please select a location for the fetch command before sending!");
        }
    };

    const generateFetchBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Fetch</HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'}  autoComplete='off' onChange={handleFetchItemChange} id="fetchItemField" label="Item..." fullWidth/>
                    </Grid>
                    <Grid item xs sx={{alignSelf:'end'}}>
                        <BodyTypography>from</BodyTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'}  onChange={handleFetchFromChange} select value={fetchFromLocation}
                                   id="fetchFromLocationField" label="Location..." fullWidth>
                            {locationNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleFetchSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleSayTextChange = (event) => {
        setSayText(event.target.value);
    };

    const handleSaySubmit = () => {
        if (/\S/.test(sayText)) {
            sendUserInput("Say " + sayText);
        } else {
            alert("Please input a message for the say command before sending!");
        }
    };

    const generateSayBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Say</HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'}  autoComplete='off' onChange={handleSayTextChange} id="sayTextField" label="Message..." fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleSaySubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleDisplayTextChange = (event) => {
        setDisplayText(event.target.value);
    };

    const handleDisplaySubmit = () => {
        if (/\S/.test(displayText)) {
            sendUserInput("Display " + displayText);
        } else {
            alert("Please input a message for the display command before sending!");
        }
    };

    const generateDisplayBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Display</HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'}  autoComplete='off' onChange={handleDisplayTextChange} id="displayTextField" label="Message..." fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleDisplaySubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    }

    const handleClearScreenSubmit = () => {
        sendUserInput("Clear Screen");
    };

    const generateClearScreenBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Clear Screen</HeaderTypography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleClearScreenSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    }

    const handlePlayVideoNameChange = (event) => {
        setPlayVideoName(event.target.value);
    };

    const handlePlayVideoSubmit = () => {
        if (/\S/.test(playVideoName)) {
            sendUserInput("Play video " + playVideoName);
        } else {
            alert("Please select a video for the play video command before sending!");
        }
    };

    const generatePlayVideoBehavior = () => {
        return (
            <>
                <Grid item container xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Play Video</HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'}  onChange={handlePlayVideoNameChange} select value={playVideoName}
                                   id="playVideoNameField" label="Name..." fullWidth>
                            {videoNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handlePlayVideoSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    }

    const handleComeHereSubmit = () => {
        if (hereLocation !== "") {
            sendUserInput("Go to " + hereLocation);
        } else {
            setOpenHere(true);
        }
    };

    function handleCloseHere() {
        setOpenHere(false);
    }

    function handleSubmitHere() {
        setHereLocation(selected);
        sendUserInput("Go to " + selected)
        setOpenHere(false)
    }

    const handleHereChange = (event) => {
        setSelected(event.target.value);
    };

    const generateComeHereBehavior = () => {
        return (
            <>
                <Grid item xs={11}>
                    <HeaderTypography>Come Here</HeaderTypography>
                </Grid>
                <Grid item xs={1}>
                    <IconButton onClick={handleComeHereSubmit}>
                        <SendIcon color="send"/>
                    </IconButton>
                </Grid>
                <Dialog
                    open={openHere}
                    onClose={handleCloseHere}
                >
                    <DialogContent>
                        <DialogContentText>
                            Please select the location of the current device
                        </DialogContentText>
                        <TextField variant={'standard'}  onChange={handleHereChange} autoFocus select value={selected}
                                   id="hereLocationField" label="Location Name..." fullWidth>
                            {locationNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseHere} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleSubmitHere} color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }

    const handleFollowMeSubmit = () => {
        sendUserInput("Follow me");
    };

    const generateFollowMeBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Follow me</HeaderTypography>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleFollowMeSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    }

    const handleGoToChange = (event) => {
        setGoToLocation(event.target.value);
    };

    const handleGoToSubmit = () => {
        if (/\S/.test(goToLocation)) {
            sendUserInput("Go to location " + goToLocation);
        } else {
            alert("Please select a location for the go to command before sending!");
        }
    };

    const generateGoToBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Go To Location</HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} onChange={handleGoToChange} select value={goToLocation}
                                   id="goToLocationField" label="Location..." fullWidth>
                            {locationNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleGoToSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleQRTextChange = (event) => {
        setQRText(event.target.value);
    };

    const handleQRHeaderChange = (event) => {
        setQRHeader(event.target.value);
    };

    const handleQRSubmit = () => {
        if (/\S/.test(QRText)) {
            if (/\S/.test(QRHeader)) {
                sendUserInput("display qr code " + QRText + " with message " + QRHeader);
            } else {
                sendUserInput("display qr code " + QRText);
            }
        } else {
            alert("Please input a url for the display qr command before sending!");
        }
    };

    const generateQRBehavior = () => {
        return (
            <>
                <Grid container xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Display QR Code</HeaderTypography>
                    </Grid>
                    <Grid item xs pr={1}>
                        <TextField variant={'standard'}  autoComplete='off' onChange={handleQRTextChange} id="qrTextField" label="URL..." fullWidth/>
                    </Grid>
                    <Grid item xs pl={1}>
                        <TextField variant={'standard'}  autoComplete='off' onChange={handleQRHeaderChange} id="qrHeaderField" label="Header..." fullWidth/>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleQRSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    const handleCheckInChange = (event) => {
        setCheckInLocation(event.target.value);
    };

    const handleCheckInSubmit = () => {
        if (/\S/.test(checkInLocation)) {
            sendUserInput("check in patients at " + checkInLocation);
        } else {
            alert("Please select a location for the check in command before sending!");
        }
    };

    const generateCheckInBehavior = () => {
        return (
            <>
                <Grid container item xs>
                    <Grid item xs={2.5}>
                        <HeaderTypography>Check In Patients At</HeaderTypography>
                    </Grid>
                    <Grid item xs>
                        <TextField variant={'standard'} onChange={handleCheckInChange} select value={checkInLocation}
                                   id="checkInLocationField" label="Location..." fullWidth>
                            {locationNames.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <IconButton  onClick={handleCheckInSubmit}>
                        <SendIcon color='send'/>
                    </IconButton>
                </Grid>
            </>
        )
    };

    var Small = {
        'zero': 0,
        'one': 1,
        'two': 2,
        'three': 3,
        'four': 4,
        'five': 5,
        'six': 6,
        'seven': 7,
        'eight': 8,
        'nine': 9,
        'ten': 10,
        'eleven': 11,
        'twelve': 12,
        'thirteen': 13,
        'fourteen': 14,
        'fifteen': 15,
        'sixteen': 16,
        'seventeen': 17,
        'eighteen': 18,
        'nineteen': 19,
        'twenty': 20,
        'thirty': 30,
        'forty': 40,
        'fifty': 50,
        'sixty': 60,
        'seventy': 70,
        'eighty': 80,
        'ninety': 90
    };

    //Location docs effect for extracting the names of our locations for our dropdown menus
    useEffect(() => {
        const locationNames = []
        locationDocs.forEach( doc => {
            if (!doc.id.startsWith("homebase") && !(doc.data().map === undefined || doc.data().raw === undefined)) {
                locationNames.push(doc.id)
            }
        })
        locationNames.push("homebase")

        //Sort location names based on numbers regardless of whether written out or not
        //Will only work for numbers 0 -> 99, with anything above 20 needing to be two words
        const locationMap = [];
        locationNames.forEach(loc => {
            const numericLoc = [];
            let tokenized = loc.split(" ");
            tokenized.forEach(token => {
                var x = Small[token];
                if (x != null) {
                    numericLoc.push(x);
                } else {
                    numericLoc.push(token);
                }
            })
            locationMap.push({"base": loc, "numeric": numericLoc.join(" ")});
        });
        locationMap.sort(function(a,b) {
            return a.numeric > b.numeric;
        })
        const sortedLocations = []
        locationMap.forEach(l => {
            sortedLocations.push(l.base);
        })
        setLocationNames(sortedLocations)

//        setLocationNames(locationNames)
    }, [locationDocs])

    //Ready to render when location names and video names are set
    useEffect(() => {
        if (locationNames !== null && locationNames !== [] && videoNames !== null && selectedBot !== undefined) {
            setIsReady(true)
        }
    }, [locationNames, videoNames, selectedBot])

    function handleComponentOpen(open) {
        setComponentOpen(!open)
    }

    if (isReady) {
        return (
                <Paper>
                    <Accordion expanded={componentOpen}>
                        <AccordionSummary onClick={() => handleComponentOpen(componentOpen)}>
                            <Grid container direction="row"
                                  justifyContent="space-between"
                                  alignItems="center">
                                <Grid item>
                                    <Typography variant="h1" color={'accordionHeader'}>Behaviors</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton size="small" onClick={() => handleComponentOpen(componentOpen)}>
                                        {componentOpen ? <KeyboardArrowUpIcon fontSize="large"/> :
                                            <KeyboardArrowDownIcon fontSize="large"/>}
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </AccordionSummary>
                        {/*<Divider className={classes.accordionDivider}/>*/}
                        <AccordionDetails>
                                <Grid container>
                                    <Grid item container xs={12} className={classes.oddGridItem}>
                                        {generateComeHereBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.evenGridItem}>
                                        {generateGoToBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.oddGridItem}>
                                        {generateEscortBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.evenGridItem}>
                                        {generateFetchBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.oddGridItem}>
                                        {generateSayBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.evenGridItem}>
                                        {generateDisplayBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.oddGridItem}>
                                        {generateClearScreenBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.evenGridItem}>
                                        {generatePlayVideoBehavior()}
                                    </Grid>

                                    <Grid item container xs={12} className={classes.oddGridItem}>
                                        {generateFollowMeBehavior()}
                                    </Grid>
                                    <Grid item container xs={12} className={classes.evenGridItem}>
                                        {generateQRBehavior()}
                                    </Grid>
                                    {dolphinEnabled ?
                                        <Grid item container xs={12} className={classes.oddGridItem}>
                                            {generateCheckInBehavior()}
                                        </Grid>
                                        :
                                        <></>
                                    }
                                </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Paper>
        );
    } else {
        return (
            <LoadingComponent/>
        )
    }
}

export default ButtonComponent